import type { SxProps, Theme } from '@mui/material/styles';

// `satisfies` rather than a `SxProps` annotation keeps these plain objects, so they can be spread into other styles
export const columnSx = { display: 'flex', flexDirection: 'column', gap: 1.5 } satisfies SxProps<Theme>;

export const listResetSx = { m: 0, p: 0, listStyle: 'none' } satisfies SxProps<Theme>;

export const answerDividerSx = { my: 1 } satisfies SxProps<Theme>;

export const widgetErrorSx = { color: 'error.main', textAlign: 'center', my: 1.5 } satisfies SxProps<Theme>;
